import { Link } from "react-router-dom";

type AccountIndicatorProps = {
  displayName: string;
  isDemo: boolean;
  demoExpiresAt: string | null;
};

function ChevronGlyph() {
  return (
    <svg
      className="hw-account-indicator__chevron"
      viewBox="0 0 12 12"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.2 4.4 6 7.2l2.8-2.8"
      />
    </svg>
  );
}

/**
 * Compact header cue for the active account/collection context.
 * Account actions live on Profile — this is not a second settings menu.
 */
export function AccountIndicator({
  displayName,
  isDemo,
  demoExpiresAt,
}: AccountIndicatorProps) {
  return (
    <Link
      to="/profile"
      className="hw-account-indicator"
      aria-label={`Профиль: ${displayName}`}
    >
      <span className="hw-shell__user" title={displayName}>
        {displayName}
      </span>
      {isDemo ? (
        <span className="hw-shell__demo" title={demoExpiresAt ?? undefined}>
          Демо
        </span>
      ) : null}
      <ChevronGlyph />
    </Link>
  );
}
